export const levelTextById = id => {
    switch (id) {
        case 1:
            return "Very Low";
        case 2:
            return "Low";
        case 3:
            return "Normal";
        case 4:
            return "High";
        default:
            return "Very High";
    }
};
